import React from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import InvoicePdf from "./InvoicePdf";
const GenrateInvoice = ({ pdfData, merchantInfo }) => {
  const fileName = pdfData && `${pdfData?.customerinfo?.customerName}-Invoice`;
  return (
    <div className="download-link">
      <PDFDownloadLink
        document={<InvoicePdf pdfData={pdfData} merchantInfo={merchantInfo} />}
        fileName={fileName}
      >
        <center>
          <button className="btn btn-success text-white my-3">
            Download Invoice
          </button>
        </center>
      </PDFDownloadLink>
    </div>
  );
};

export default GenrateInvoice;
